import { DeliveryDateType } from "@/core/api/apiClient";

const mapping: Record<DeliveryDateType, string> = {
  NotConfirmed: "Not Confirmed",
  WillCall: "Will Call",
  At: "At",
  Before: "Before",
  After: "After",
  Anytime: "Anytime",
  ASAP: "ASAP"
};

export function mapDeliveryDateType(key: DeliveryDateType | string): string {
  return mapping[key as DeliveryDateType] ?? key;
}

export default mapDeliveryDateType;
